/**
 * Add Entitys page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Directive, Input, SimpleChanges, TemplateRef, ViewContainerRef, PipeTransform, Pipe, Component, ViewChild, ElementRef, ViewEncapsulation, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController, LoadingController, ModalController, AlertController, Platform, ActionSheetController, NavParams } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WebcamImage, WebcamInitError } from 'ngx-webcam';
declare var require: any;
import * as moment from 'moment';

/**
 * Services
 */
import { PouchService } from '../services/pouch-service';
import { ImageService } from '../services/image';
import { FileViewerPage } from '../fileviewer/fileviewer';

@Component({
  selector: 'page-add-entity',
  templateUrl: 'add-entity.html',
  styleUrls: ['add-entity.scss'],
  encapsulation: ViewEncapsulation.None,
  //providers: [NavParams]
})
export class AddEntityPage {
  navParams = {};
  @Input() mode: string = 'entity';
  @Input() showsave: boolean = true;
  @Input() locked: boolean = false;
  @Input() ispage: boolean = true;
  @Input() isobject: boolean = false;
  @Input() isform: boolean = false;
  objectKeys = Object.keys;
  @Input() entity: any = {
    id: Math.round(new Date().getTime()).toString(),
  };
  @Input() setting: any = {
    keys: [],
  };
  @Input() hidefileinput: boolean = false;
  @Input() hidelist = ['customer', 'user', 'user_name'];
  @Input() includelist = [];
  @Input() labellist = ['input', 'number', 'password', 'text', 'select', 'checkbox', 'date', 'datetime-local', 'signature', 'image'];
  @Input() disabledlist = [];
  @Input() inputkeys = [];
  @ViewChild('fileinput') fileinput: ElementRef;
  forms = [];
  title = 'Add';
  objects: any = {};
  public webcam; //will be populated by ack-webcam [(ref)]
  oncam = false;
  showfileinput = false;
  @Input() save = true; //save data or just exit after clicking submit
  showtip = true;
  mindate = 1900;
  maxdate = new Date().getFullYear() + 50;
  frompage = ''; // the page from where the page was called
  // latest snapshot
  public webcamImage: WebcamImage = null;
  subscriptions: any = {};
  loading: any;
  images: any = {};
  comment = '';

  constructor(
    injector: Injector,
    public loadingCtrl: LoadingController,
    public http: HttpClient,
    public alertCtrl: AlertController,
    public _DomSanitizer: DomSanitizer,
    public imageService: ImageService,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public platform: Platform,
    public db: PouchService,
    private router: Router
  ) {
    let navParams2: any = {};
    if (router.url != '/AddEntityPage') {
      navParams2 = injector.get(NavParams);
    }
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
    // console.log(this.navParams, navParams2.data);
  }

  ionViewWillLeave() {
    let subscriptions = Object.keys(this.subscriptions);
    subscriptions.map((subscription) => {
      this.subscriptions[subscription].unsubscribe();
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      if (key == 'entity' && (changes[key].currentValue == undefined || Object.keys(changes[key].currentValue).length === 0)) {
        changes[key].currentValue = {
          id: Math.round(new Date().getTime()).toString(),
        };
      }
      if (changes[key].currentValue != undefined) {
        this[key] = changes[key].currentValue;
        this.navParams[key] = changes[key].currentValue;
      }
    });
    /* this.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.loading.present(); */
    this.generateFields(this.entity, this.setting).then(async (res) => {
      // console.log(res, this.loading);
      // await this.loading.dismiss();
      this.ngOnInit();
    });
  }

  generateFields(entity, setting) {
    if (entity == undefined) entity = {};
    return new Promise((resolve, reject) => {
      Promise.all(
        setting.keys.map(async (key) => {
          //load object sources
          if (entity[key] == undefined || entity[key] == '') {
            //prevent undefined loading old value
            if (setting[key].val != undefined && setting[key].val != '') {
              entity[key] = setting[key].val;
            } else if (setting[key].type == 'id' || setting[key].type == 'rev' || setting[key].type == 'array' || setting[key].type == 'connectedobject') {
              //do nothing
            } else if ((setting[key].type == 'object' || setting[key].type == 'objectfilter') && setting[key].showdoc) {
              await this.db.get(key, 'setting').then((objsetting) => {
                this.generateFields({}, objsetting).then((obj) => {
                  entity[key] = obj;
                });
              });
            } else if (setting[key].type == 'number') {
              entity[key] = 0;
            } else if (setting[key].type == 'checkbox') {
              entity[key] = setting[key].val || false;
            } else if (setting[key].type == 'texteditor') {
              entity[key] = {
                name: this.db.rename(key),
                content: '',
                date: moment().format('YYYY-MM-DDTHH:mm'),
              };
            } else {
              entity[key] = '';
            }
          }
        })
      ).then((res) => {
        resolve(entity);
      });
    });
  }

  ngOnInit() {
    if (this.navParams != undefined && this.navParams['mode'] != undefined) {
      this.mode = this.navParams['mode'];
    }
    if (this.navParams != undefined && this.navParams['save'] != undefined) {
      this.save = this.navParams['save'];
    }
    if (this.navParams != undefined && this.navParams['hidelist'] != undefined) {
      // set hidelist that will not be shown in the form
      this.hidelist = this.navParams['hidelist'];
    }
    if (this.navParams != undefined && this.navParams['hidefileinput'] != undefined) {
      this.hidefileinput = this.navParams['hidefileinput'];
    }
    if (this.navParams != undefined && this.navParams['disabledlist'] != undefined) {
      this.disabledlist = this.navParams['disabledlist'];
    }
    if (this.navParams != undefined && this.navParams['frompage'] != undefined) {
      this.frompage = this.navParams['frompage'];
    }
    if (this.navParams != undefined && this.navParams['isform'] != undefined) {
      this.isform = this.navParams['isform'];
    }
    this.load();
  }

  load() {
    this.db.get(this.mode, 'setting').then((setting) => {
      // Get Setting
      //get settings from form
      if (this.isform) {
        setting = this.navParams['entity'].setting;
      }
      this.setting = setting;
      let keys = setting.keys;
      keys.map((key) => {
        if (key.includes('_name') && !this.includelist.includes(key) && keys.includes(key.replace('_name', ''))) {
          if (Array.isArray(this.hidelist)) {
            this.hidelist.push(key);
          }
        }
      });
      // add defaults for new docs
      if (!this.entity.rev && this.db.appinfo.product === 'property' && this.db.lease) {
        this.entity.tenant = this.db.lease?.tenant;
        this.entity.tenant_name = this.db.lease?.tenant_name;
        this.entity.tenant_mobile = this.db.lease?.tenant_mobile;
        this.entity.tenant_email = this.db.lease?.tenant_email;
        this.entity.property = this.db.lease.property;
        this.entity.property_name = this.db.lease.property_name;
      }
      this.setting.keys = this.setting.keys.filter((key) => !this.hidelist.includes(key)); // do not show hidden keys on the page template
      keys.map((key) => {
        //load object sources
        if (setting[key].type == 'object' || setting[key].type == 'connectedobject' || setting[key].type == 'arraytags' || setting[key].type == 'arrayinput' || setting[key].type == 'objectfields' || setting[key].type == 'objectfilter') {
          this.objects[key] = []; //quickly initialize to prevent constructor error while waiting for subscription results
          if (setting[key].type == 'connectedobject' || setting[key].type == 'arraytags' || setting[key].type == 'arrayinput' || setting[key].type == 'objectfields') {
            //correct the object to include
            this.entity[key] = '';
            key = setting[key].val;
          }
          this.subscriptions[key] = this.db.getAllRx(key).subscribe((results) => {
            if (results != null) {
              //remove settng database
              if (key == 'setting') {
                this.objects[key] = results.filter((result) => result.id != this.db.gsetting.id);
              } else {
                if (setting[key]?.type == 'objectfilter') {
                  // store all , to help with multiple filters
                  if (this.entity[setting[key].val] == undefined) {
                    this.disabledlist.push(key);
                    this.objects[key] = results;
                  } else {
                    this.objects[key] = results.filter((result) => result[setting[key].val] == this.entity[setting[key].val]);
                  }
                  this.objects[`all_${key}`] = results;
                } else {
                  this.objects[key] = results;
                }
              }
              if (this.objects[key + 'name'] == undefined) {
                this.objects[key + 'name'] = ''; // put under the if condition to avoid changing it if it has already been added by the Add Entity if statement below
              }
            } else {
              this.setting.keys = this.setting.keys.filter((k) => k != key && k != key + '_name' && setting[k].val != key);
            }
          });
        } else if (setting[key].type == 'form') {
          this.subscriptions['form'] = this.db.getAllRx('form').subscribe((results) => {
            this.forms = results;
          });
        }
      });
      if (this.navParams != undefined && this.navParams['entity'] != undefined) {
        // Edit Entity
        this.title = this.navParams['title'] != undefined ? this.navParams['title'] : 'Edit';
        this.entity = this.navParams['entity'];
        this.inputkeys = Object.keys(this.entity).filter((key) => key.startsWith('@'));
        //get all images in attachments as urls
        this.getImageAttachments();
        keys.map((key) => {
          //load object sources
          //objects
          if (((setting[key].type == 'object' && !setting[key]?.showdoc) || setting[key].type == 'objectfilter') && this.entity[key] != undefined) {
            this.db.get(this.entity[key], key).then((result) => {
              if (result != undefined) {
                this.objects[key + 'name'] = this.formatter(result);
              }
            });
          }
          //images load from attachments
          if (setting[key].type == 'image' && this.entity.attachments != undefined && this.entity.attachments[key] != undefined) {
            this.db.getAttachment(this.mode, this.entity.id, key).then((file) => {
              this.images[key] = URL.createObjectURL(file);
            });
          }
          //connected object
          if (setting[key].type == 'connectedobject' && this.entity[key] != undefined) {
            this.db.get(this.entity[key], setting[key].val).then((result) => {
              if (result != undefined) {
                this.objects[key + 'name'] = this.formatter(result);
              }
            });
          }
          //repair date
          if (setting[key].type == 'datetime-local' && this.mode != 'booking') {
            this.entity[key] = moment(this.entity[key]).format('YYYY-MM-DDTHH:mm');
          }

          //restrict usertype and home page for non admin user
          if ((key == 'usertype' || key == 'homepage' || key == 'pages') && this.db.user.usertype != 'Admin') {
            this.setting.keys = this.setting.keys.filter((dkey) => key != dkey);
          }
        });
      } else if (this.ispage) {
        //Add Entity (not available for component type)
        this.entity = {};
        this.entity.id = Math.round(new Date().getTime()).toString();
        this.entity.rev = '';
        this.entity._attachments = {};
        keys.map((key) => {
          if (key != 'id' && key != 'rev') {
            if (this.setting[key].val != undefined) {
              //replace with the settings default value
              this.entity[key] = this.setting[key].val;
            }
            if (this.navParams != undefined && this.navParams[key] != undefined) {
              //if the key value has been passed through navparam for example: customer id or user id
              this.entity[key] = this.navParams[key]; //then initialize customer
              if (setting[key].type == 'object' || setting[key].type == 'objectfilter' || setting[key].type == 'connectedobject' || this.mode == 'sale') {
                // if it is an object, then find the name so you can display it well
                this.db.get(this.entity[key], key).then((result) => {
                  if (result != undefined) {
                    if (setting[key].type == 'object' || setting[key].type == 'objectfilter') {
                      //for object show the name of the customer or user...
                      this.objects[key + 'name'] = this.formatter(result);
                    } else if (this.mode == 'sale') {
                      this.entity[key] = this.formatter(result); //replace id with name for sale
                    }
                  }
                });
              } else if (setting[key].type == 'date') {
                this.entity[key] = moment(this.entity[key]).format('YYYY-MM-DD');
              } else if (setting[key].type == 'datetime-local') {
                this.entity[key] = moment(this.entity[key]).format('YYYY-MM-DDTHH:mm');
              }
            } else if (key == 'date') {
              //Always initialize date to current date to make it easier to add
              this.entity[key] = this.db.localDate(setting[key].type);
            } else if (setting[key].type == 'array' || setting[key].type == 'arraytags') {
              this.entity[key] = [];
            }
          }
        });
        /* if (this.navParams != undefined && this.navParams['date'] != undefined) { //for calendar
                    let date = this.navParams['date');
                    var now = new Date();
                    if (date.length === 10) {
                        date = new Date(new Date(date).setHours(now.getHours())).toISOString();
                    }
                    this.entity.date = date;
                    this.entity.end = new Date(new Date(date).setMinutes(new Date(date).getMinutes() + 30)).toISOString(); //Also set end time to date
                } */
        //preset prescription number
        if (this.setting.keys.includes('prescription_number')) {
          this.entity['prescription_number'] = 'Rx ' + Math.round(new Date().getTime() / 1000).toString();
        }
        if (this.db.user != undefined) {
          //created by
          this.entity.created_by = this.db.user.fullname;
          this.entity.created_date = new Date().toLocaleString();
        }
      }
    });
  }

  getImageAttachments() {
    if (this.entity.attachments != undefined) {
      let imagekeys = Object.keys(this.entity.attachments).filter((key) => this.isImageFile(key) || this.entity.attachments[key].content_type?.startsWith('image/'));
      imagekeys.map((key) => {
        this.db.getAttachment(this.mode, this.entity.id, key).then((file) => {
          this.images[key] = URL.createObjectURL(file);
        });
      });
    }
  }

  isImageFile(filename: string) {
    return /\.(jpe?g|png|bmp|svg|gif|webp)$/i.test(filename || '');
  }

  viewReference(reference) {
    if (reference.mode == 'customer') {
      this.router.navigateByUrl('/CustomerManagementPage', {
        state: { customer_id: reference.id, showsearch: false },
      });
    } else if (reference.mode == 'zoommeeting') {
      this.db.get(reference.id, 'zoommeeting').then((meeting) => {
        this.router.navigateByUrl('/ZoomPage', {
          state: { meeting: meeting, showsearch: false },
        });
      });
    } else {
      //entity
      this.db.get(reference.id, reference.mode).then((entity) => {
        this.router.navigateByUrl('/AddEntityPage', {
          state: { entity: entity, mode: reference.mode },
        });
      });
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  sign($event, item) {
    if ($event.value) {
      this.entity[item] = this.db.user.fullname;
      if (this.setting.keys.includes('validated_date')) {
        this.entity.validated_date = moment().format('YYYY-MM-DDTHH:mm');
      }
    }
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  formformatter(item) {
    return item['@name'] + ' ____ ' + item['@department'];
  }

  arrayinputformatter(item) {
    let value = '';
    if (item.name != undefined) {
      value += item.name;
    }
    if (item.title != undefined) {
      value += item.title;
    }
    if (item.specimen != undefined) {
      value += ' ____ ' + item.specimen;
    }
    if (item.conventional_unit != undefined) {
      value += ' ____ ' + item.conventional_unit;
    }
    if (item.modality != undefined) {
      value += ' ____ ' + item.modality;
    }
    return value;
  }

  formatter(item) {
    // nice input list array, show the name, username or date to identify the object
    //for date of birth in prescription
    if (item.date_of_birth != undefined && this.mode == 'prescription') {
      this.entity.date_of_birth = item.date_of_birth;
    }
    //proceed default
    if (item.name != undefined) {
      return item.name;
    } else if (item.title != undefined) {
      return item.title;
    } else if (item.fullname != undefined) {
      return item.fullname;
    } else if (item.date != undefined) {
      return item.date;
    } else {
      return item.id;
    }
  }

  selectForm(setting) {
    if (this.entity.forms == undefined) {
      this.entity.forms = [];
    }
    let form = {
      id: Math.round(new Date().getTime()).toString(),
      rev: '',
      ['@date']: moment().format('YYYY-MM-DDTHH:mm'),
      ['@name']: setting['@name'],
      status: 'Pending',
      created_by: this.db.user.fullname,
      created_date: new Date().toLocaleString(),
      setting: setting,
    };
    this.entity.forms.unshift(form);
  }

  selectItem(val, item) {
    if (val.id != undefined) {
      this.entity[item] = val.id;
      this.objects[item + 'name'] = this.formatter(val); // use formatter function to return the appropriate name for the selected object

      if (this.setting[item].type == 'arrayinput') {
        if (val.is_parent == true && val.children != undefined) {
          val.children.map((child) => {
            this.entity.item = '';
            this.entity['@' + child.name] = '';
          });
          this.inputkeys = Object.keys(this.entity).filter((key) => key.startsWith('@'));
        } else {
          this.entity.item = '';
          this.entity['@' + val.name] = '';
          this.inputkeys = Object.keys(this.entity).filter((key) => key.startsWith('@'));
        }
      } else if (this.setting[item].type == 'objectfields') {
        this.db.get(this.setting[item].val, 'setting').then((setting) => {
          setting.keys.map((key) => {
            if (this.setting.keys.includes(key)) {
              this.entity[key] = val[key];
            }
          });
        });
      }
      this.setting.keys.map((key) => {
        if (this.setting[key].type == 'objectfilter' && this.setting[key].val == item) {
          this.disabledlist = this.disabledlist.filter((k) => k !== key);
          this.objects[key] = this.objects[`all_${key}`].filter((result) => result[item] == this.entity[item]);
        }
      });

      //if entity name is also a field set is automatically
      if (this.setting.keys.includes(item + '_name') || this.hidelist.includes(item + '_name')) {
        this.entity[item + '_name'] = this.formatter(val);
      }

      //if bed allotment, set the name as the patient name
      if (this.mode == 'booking') {
        this.entity.name = this.formatter(val);
      }

      //if specimen, and patient is selected, limit lab request to show only patient request
      if (this.mode == 'specimen' && item == 'customer') {
        this.objects['laboratoryrequest'] = this.objects['laboratoryrequest'].filter((request) => request.customer == val.id);
      }

      //if user_type is a field
      if (item == 'user' && this.setting.keys.includes('user_type')) {
        this.entity['user_type'] = val.usertype;
      }
    }
  }

  async viewEntity(id, item, type = '') {
    console.log(id, item, type);
    if (type == 'object') {
      //id is actual entity
      let modal = await this.modalCtrl.create({
        component: AddEntityPage,
        componentProps: { entity: id, mode: item, isobject: true },
      });
      modal.onDidDismiss().then((res) => {
        if (res.data != undefined) {
          this.entity[item] = res.data;
        }
      });
      const { data } = await modal.onWillDismiss();
      return await modal.present();
    } else if (type == 'form') {
      //id is actual form
      let modal = await this.modalCtrl.create({
        component: AddEntityPage,
        componentProps: { entity: id, mode: item, isform: true },
      });
      modal.onDidDismiss().then((res) => {
        if (res.data != undefined) {
          this.entity.forms[this.entity.forms.findIndex((form) => form.id == res.data['id'])] = res.data;
          this.db.update(this.entity, this.mode).then((res) => {
            this.presentToast('Form Saved Successfully', 'toast-success');
          });
        }
      });
      return await modal.present();
    } else if (id == undefined || id == '') {
      let modal = await this.modalCtrl.create({
        component: AddEntityPage,
        componentProps: { mode: item },
      });
      modal.onDidDismiss().then((res) => {
        if (res.data != undefined) {
          this.entity[item] = res.data['id'];
          this.db.update(this.entity, this.mode);
        }
      });
      return await modal.present();
    } else {
      this.db.get(id, item).then(async (entity) => {
        let modal = await this.modalCtrl.create({
          component: AddEntityPage,
          componentProps: { entity: entity, mode: item },
        });
        modal.onDidDismiss().then((res) => {
          if (res.data != undefined) {
            this.entity[item] = res.data['id'];
            this.db.update(this.entity, this.mode);
          }
        });
        return await modal.present();
      });
    }
  }

  viewEntities(item) {
    this.router.navigateByUrl('/EntitysPage', {
      state: { mode: item, parent: this.setting.id, val: this.entity.id },
    });
  }

  check() {
    let pass = true;
    this.setting.keys.map((key) => {
      if (key == 'status' && this.entity[key] == 'Completed' && this.entity.date_completed == undefined) {
        //set completed date for entities like radiology, and laboratory requests
        this.entity.date_completed = moment().format('YYYY-MM-DDTHH:mm');
      }
      if (this.setting[key].type == 'object' || this.setting[key].type == 'objectfilter') {
      } else if (this.setting[key].required && (this.entity[key] == undefined || this.entity[key] === '')) {
        pass = false;
      }
    });
    //for updating inventory for product loan page
    if (this.mode == 'productloan') {
      if (this.entity.complete == undefined) {
        this.entity.complete = false;
        this.db.get(this.entity.product, 'product').then((product) => {
          product.quantity = parseFloat(product.quantity) - parseFloat(this.entity.quantity_borrowed);
          this.db.update(product, 'product');
        });
      } else if (this.entity.complete == false && this.entity.status == 'returned') {
        this.entity.complete = true;
        this.db.get(this.entity.product, 'product').then((product) => {
          product.quantity = parseFloat(product.quantity) + parseFloat(this.entity.quantity_returned);
          this.db.update(product, 'product');
        });
      } else if (this.entity.complete == false && (this.entity.quantity_returned != 0 || this.entity.date_returned != undefined)) {
        pass = false;
        this.presentToast('Please change status to returned', 'toast-danger');
      }
    }
    return pass;
  }

  submit() {
    if (this.check()) {
      if (this.save && (this.navParams['isobject'] != true || this.navParams['isform'] != true)) {
        //dont save object
        if (this.title == 'Add' && this.mode == 'category') {
          //nice name for category id
          this.entity.id = this.entity.name.replace(/[^A-Z0-9]/gi, '_').substring(0, 16);
        }
        this.db.update(this.entity, this.mode).then((entity) => {
          this.dismiss(entity);
        });
      } else {
        this.dismiss(this.entity);
      }
    } else {
      this.presentToast('Enter Required Fields', 'toast-danger');
    }
  }

  dismiss(entity) {
    if (this.ispage) {
      this.modalCtrl.dismiss(entity);
    } else {
      this.presentToast('Item was saved Successfully', 'toast-success');
    }
  }

  async picture(item) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: 'Add Product Picture?',
      buttons: [
        {
          text: 'From Camera',
          handler: () => {
            this.camera(item);
          },
        },
        {
          text: 'Select Picture',
          handler: () => {
            if (this.platform.is('cordova')) {
              this.selectImage(item);
            } else {
              this.showfileinput = true;
            }
          },
        },
        {
          text: this.db.rename('Cancel'),
          role: 'cancel',
          handler: () => {},
        },
      ],
    });
    actionSheet.present();
  }

  camera(item) {
    if (this.platform.is('cordova')) {
      this.imageService
        .takePhotograph()
        .then((image) => {
          this.entity[item] = image.toString();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (this.oncam) {
        this.imageService.trigger.next();
      } else {
        this.oncam = true;
      }
    }
  }

  cancelcamera() {
    this.oncam = false;
  }

  filter(item, filter, val) {
    return this.objects[item].filter((object) => object[filter] == val);
  }

  deleteKey(key) {
    delete this.entity[key];
    this.inputkeys = Object.keys(this.entity).filter((key) => key.startsWith('@'));
  }

  getAttachments() {
    return Object.keys(this.entity.attachments).filter((key) => this.entity.attachments[key].comment != true);
  }

  download(item) {
    var file = this.entity._attachments[item].data;
    var url = null;
    if (navigator.msSaveBlob) {
      url = navigator.msSaveBlob(file, this.entity[item]);
    } else {
      url = window.URL.createObjectURL(file);
    }
    var tempLink = document.createElement('a');
    tempLink.href = url;
    tempLink.setAttribute('download', this.entity[item]);
    tempLink.click();
    window.URL.revokeObjectURL(url);
  }

  imageListener($event, item): void {
    if (this.entity.attachments == undefined) {
      this.entity.attachments = {};
    }
    var file: File = $event.target.files[0];
    this.entity.attachments[item] = {
      type: file.type,
      data: file,
      name: file.name,
      content_type: file.type,
    };
    this.entity[item] = undefined; //unset this to prevent previous data from loading
    this.images[item] = URL.createObjectURL(file); //now set it to show for the first time.
  }

  private readFileAsBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => {
        const res = fr.result as string; // "data:...;base64,AAAA..."
        const base64 = res.split(',')[1] ?? '';
        resolve(base64);
      };
      fr.onerror = reject;
      fr.readAsDataURL(file);
    });
  }

  async fileListener(filesOrEvent: any, item: any, iscomment = false) {
    // Normalize to a File[]
    let files: File[] = [];

    if (filesOrEvent?.target?.files) {
      // called as fileListener($event)
      files = Array.from(filesOrEvent.target.files as FileList);
    } else if (typeof FileList !== 'undefined' && filesOrEvent instanceof FileList) {
      files = Array.from(filesOrEvent as FileList);
    } else if (filesOrEvent instanceof File) {
      files = [filesOrEvent as File];
    } else if (Array.isArray(filesOrEvent)) {
      files = filesOrEvent as File[];
    } else if (filesOrEvent?.files) {
      // some wrappers put files under `.files`
      files = Array.from(filesOrEvent.files as FileList);
    }

    if (!files.length) return;

    if (!this.entity.attachments) this.entity.attachments = {};

    const tasks = files.map(async (file) => {
      const base = await this.readFileAsBase64(file);
      const dot = file.name.lastIndexOf('.');
      const ext = dot >= 0 ? file.name.substring(dot) : '';
      const stem = dot >= 0 ? file.name.substring(0, dot) : file.name;
      const today = new Date().toISOString().split('T')[0];
      const filename = `${stem}_${today}${ext}`.replace(/\//g, '-');

      this.entity.attachments[filename] = {
        content_type: file.type || 'application/octet-stream',
        data: base,
        iscomment: iscomment,
      };

      if (this.isImageFile(filename) || file.type.startsWith('image/')) {
        this.images[filename] = URL.createObjectURL(file);
      }
    });

    await Promise.all(tasks);

    // safely clear the input if it exists
    const el: any = document.getElementById('commentfileinput');
    if (el && 'value' in el) el.value = '';

    this.submit();
  }

  addComment(item, file = '') {
    //error check
    if (this.entity[item] == undefined || this.entity[item] == '') {
      this.entity[item] = [];
    }
    this.entity[item].unshift({
      id: Math.round(new Date().getTime()).toString(),
      date: this.db.localDate(),
      user: this.db.user.fullname || this.db.user.name,
      comment: this.comment,
      file: file,
    });
    this.comment = '';
    this.db.update(this.entity, this.mode).then((entity) => {
      this.presentToast('Comment Added Successfully', 'toast-success');
      //this.getImageAttachments(); commented out as you cannot load this from a component page like task page without gounf through @Input() route
    });
  }

  viewFile(item) {
    this.db.getAttachment(this.mode, this.entity.id, item).then(async (attachment) => {
      let modal = await this.modalCtrl.create({
        component: FileViewerPage,
        componentProps: { attachment: attachment, name: item },
      });
      modal.onDidDismiss().then((res) => {
        console.log(res);
        /* if (res.data != undefined) {
            this.entity[item] = res.data;
          } */
      });
      return await modal.present();
    });
  }

  selectImage(item) {
    this.imageService
      .selectPhotograph()
      .then((image) => {
        this.entity[item] = image.toString();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public handleImage(webcamImage: any, item): void {
    if (this.entity.attachments == undefined) {
      this.entity.attachments = {};
    }
    this.db.urltoFile(webcamImage.imageAsDataUrl, item, 'image/png').then((file) => {
      this.entity.attachments[item] = {
        type: file.type,
        data: file,
        name: file.name,
        content_type: file.type,
      };
      this.entity[item] = undefined; //unset this to prevent previous data from loading
      this.images[item] = URL.createObjectURL(file); //now set it to show for the first time.
      this.oncam = false;
    });
  }

  dictionary() {
    this.router.navigateByUrl('/DrugDictionaryPage', {});
  }

  async sendSMS() {
    this.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.loading.present();
    if (this.entity.customer != undefined) {
      this.db.get(this.entity.customer, 'customer').then(async (customer) => {
        if (customer.mobile != undefined && customer.mobile != '') {
          let message = 'Dear ' + customer.name + ', Your Appointment has been scheduled for ' + this.db.rename(this.entity.date, 'date') + ' with ' + this.objects['username'];
          if (this.entity.zoom_meeting_id != undefined && this.entity.zoom_meeting_id != '') {
            message += '. Zoom Meeting ID: ' + this.entity.zoom_meeting_id + '. Zoom Password: ' + this.entity.zoom_meeting_password;
          }
          let phone = customer.mobile;
          if (!phone.startsWith(this.db.gsetting.sms.prefix)) {
            //if local
            phone = phone.charAt(0) == '0' ? phone.substring(1) : phone; //add prefix
            phone = this.db.gsetting.sms.prefix + phone;
          }
          const alert = await this.alertCtrl.create({
            header: 'Send SMS to ' + customer.name,
            inputs: [
              {
                name: 'phone',
                type: 'text',
                value: phone,
              },
              {
                name: 'message',
                type: 'textarea',
                value: message,
              },
            ],
            buttons: [
              {
                text: this.db.rename('Cancel'),
                handler: async () => {
                  await this.loading.dismiss();
                },
              },
              {
                text: this.db.rename('Confirm'),
                handler: (ddata) => {
                  let headers = new HttpHeaders();
                  headers.append('Content-Type', 'application/json');
                  headers.append('Access-Control-Allow-Origin', '*');
                  let data = {
                    country: this.db.gsetting.country,
                    from: this.db.gsetting.phone,
                    to: ddata.phone,
                    message: ddata.message,
                  };
                  this.http.post('https://sarutech.com:4000/send_message', data).subscribe(
                    async (res) => {
                      await this.loading.dismiss();
                      this.presentToast(res['status'], 'toast-success');
                    },
                    async (err) => {
                      await this.loading.dismiss();
                      this.presentToast(err, 'toast-danger');
                    }
                  );
                },
              },
            ],
          });
          alert.present();
        } else {
          await this.loading.dismiss();
          this.presentToast('Please Enter the Patient Phone Number', 'toast-danger');
        }
      });
    } else {
      await this.loading.dismiss();
      this.presentToast('Please select a patient', 'toast-danger');
    }
  }

  sendEmail() {
    if (this.entity.customer != undefined) {
      this.db.get(this.entity.customer, 'customer').then((customer) => {
        if (customer.email != undefined && customer.email != '') {
          let subject = 'Appointment with ' + this.objects['username'] + ' for ' + this.db.rename(this.entity.date, 'date');
          let message = 'Dear ' + customer.name + ', Your Appointment has been scheduled for ' + this.db.rename(this.entity.date, 'date') + ' with ' + this.objects['username'];
          if (this.entity.zoom_meeting_id != undefined && this.entity.zoom_meeting_id != '') {
            message += '. \n\n Zoom Meeting ID: ' + this.entity.zoom_meeting_id + '. \n Zoom Password: ' + this.entity.zoom_meeting_password;
            message += ' \n\n ' + this.entity.zoom.join_url;
          }
          message += '. \n\n Kind Regards, \n ' + this.db.gsetting.company;
          this.db.email(customer.email, subject, message);
        } else {
          this.presentToast('Please Enter the Patient Email Address', 'toast-danger');
        }
      });
    } else {
      this.presentToast('Please select a patient', 'toast-danger');
    }
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }

  back() {
    //this.navCtrl.pop();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
